export default {
  onb: {
    newPartner: 'Новый поставщик',
    newPartnerEyebrow: 'Подключение на выезде',
    newPartnerDesc: 'Кабинет поставщика создаётся прямо во время визита. Обязательно только название, остальное можно дополнить позже.',
    create: 'Создать кабинет',
    creating: 'Создаём…',
    created: 'Кабинет создан',
    openOnboarding: 'Онбординг',
    eyebrow: 'Подключение поставщика',
    title: 'Онбординг: {{name}}',
    description: 'Кабинет → прайс → превью → одобрение поставщика → договор → отправка на сайт. Каждый шаг пишется в журнал.',
    steps: { cabinet: 'Кабинет', pricelist: 'Прайс', preview: 'Превью', approval: 'Одобрение', contract: 'Договор', send: 'На сайт' },
    back: 'К партнёру',
    save: 'Сохранить',
    saving: 'Сохраняем…',
    saved: 'Сохранено',
    cancel: 'Отмена',
    required: 'Обязательно',
    sectionCompany: 'Компания',
    sectionContacts: 'Контакты',
    sectionWarehouse: 'Склад и самовывоз',
    sectionTerms: 'Коммерческие условия',
    sectionSite: 'Значения для витрины',
    name: 'Юридическое название',
    shortName: 'Короткое имя',
    trn: 'TRN (15 цифр)',
    address: 'Юридический адрес',
    websiteUrl: 'Сайт',
    categories: 'Категории (через запятую)',
    contact: 'Владелец / контактное лицо',
    role: 'Должность',
    phone: 'Телефон',
    whatsapp: 'WhatsApp',
    email: 'E-mail',
    city: 'Город',
    warehouse: 'Адрес склада (самовывоз)',
    pickupHours: 'Часы самовывоза',
    discount: 'Скидка партнёра, %',
    noDiscountOnSpecial: 'Скидка не действует на спецпредложения',
    markup: 'Наценка B2C, % (пусто — общая)',
    markupB2b: 'Наценка B2B, % (пусто — общая)',
    minResaleType: 'Правило минимальной цены',
    minResaleValue: 'Значение минимума',
    minResale: { none: 'Нет', partner_price: 'Не ниже цены партнёра', markup_over_cost: 'Наценка к себестоимости, %', per_sku: 'По SKU' },
    reservationPeriodDays: 'Удержание резерва, дней',
    reservationRespondHours: 'Ответ по брони, часов',
    poConfirmHours: 'Подтверждение PO, часов',
    paymentLagDays: 'Оплата после клиента, рабочих дней',
    warrantyMonths: 'Гарантия, месяцев',
    deliveryDays: 'Срок доставки на сайте (мин–макс)',
    brandVisible: 'Показывать бренд партнёра на сайте',
    brandVisibleDesc: 'По умолчанию выключено: сайт не называет партнёра (ТЗ п.2.2).',
    statusLabel: 'Статус',
    logo: 'Логотип',
    uploadLogo: 'Загрузить логотип',
    inviteOwner: 'Пригласить владельца в портал',
    inviteEmail: 'E-mail владельца',
    inviteName: 'Имя владельца',
    invite: 'Отправить приглашение',
    invited: 'Приглашение отправлено на {{email}}',
    inviteLink: 'Ссылка приглашения (почта не настроена):',
    notes: 'Заметки (только для Treejar)',
    plUpload: 'Загрузить прайс',
    plUploadDesc: 'PDF, Excel, CSV или фото страниц уходят в AI-импорт. Запускайте в начале визита: 40 страниц разбираются около 20 минут.',
    plOpenImport: 'Открыть импорт для этого поставщика',
    plVersions: 'Версии прайса',
    plNoVersions: 'Прайсов ещё нет.',
    plVersion: 'v{{n}}',
    plItems: '{{count}} позиций',
    plOpen: 'Открыть',
    prevTitle: 'Как карточки будут выглядеть на treejartrading.ae',
    prevDesc: 'Названия по правилу сайта «Тип + артикул + цвет», цены — по каналам. Нажмите на карточку, чтобы править.',
    supplierMode: 'Режим показа поставщику',
    supplierModeDesc: 'Скрывает закупочные цены и наценки, пока смотрит поставщик.',
    channel: 'Сайт для',
    channelB2c: 'покупателей (B2C)',
    channelB2b: 'дилеров (B2B)',
    filterAll: 'Все типы',
    sort: { stock: 'Остаток (по убыванию)', priceAsc: 'Цена (по возрастанию)', priceDesc: 'Цена (по убыванию)', name: 'Название (А–Я)' },
    products: '{{count}} товаров',
    price: 'Price: AED {{value}}',
    exclVat: 'excl. VAT',
    inStock: '{{count}} in stock',
    onRequest: 'on request',
    inTransit: '{{count}} in transit',
    addToCart: 'Add to Cart',
    cardAnno: 'Поставщик AED {{cost}} · B2C {{b2c}} ({{mB2c}}) · B2B {{b2b}} ({{mB2b}})',
    manual: 'ручная',
    rrp: 'RRP',
    cardCost: 'Закупка (прайс)',
    cardRrp: 'Реком. цена поставщика',
    cardOurPrice: 'Наша цена на сайте',
    cardOurPriceB2b: 'Наша цена B2B',
    cardMargin: 'Маржа',
    cardManualHint: 'Ручная цена; очистите поле, чтобы вернуть расчёт по наценке ({{value}})',
    cardCalcHint: 'Цена по наценке канала; введите своё значение — маржа пересчитается сразу, сохранение при выходе из поля',
    excluded: 'Исключено поставщиком',
    noImage: 'Нет фото',
    tabCards: 'Карточки',
    tabPrices: 'Цены',
    tabSend: 'Готовность',
    pricesTitle: 'Цены по каналам, RRP поставщика и наценки',
    pricesDesc: 'B2C и B2B считаются от цены поставщика и наценки канала; введённое значение — ручная цена (оранжевая), очистите поле, чтобы вернуться к наценке. RRP — рекомендованная цена поставщика: показывает, какую наценку закладывает сам поставщик, и насколько наша B2C от неё отличается.',
    colSku: 'SKU',
    colName: 'Название',
    colStock: 'Остаток',
    colCost: 'Цена поставщика',
    colRrp: 'RRP поставщика',
    colRrpMarkup: 'Наценка RRP',
    colB2c: 'B2C сайт',
    colB2cMarkup: 'Наценка B2C',
    colB2cVsRrp: 'B2C к RRP',
    colB2b: 'B2B дилер',
    colB2bMarkup: 'Наценка B2B',
    colMargin: 'Маржа B2C',
    colStatus: 'Статус',
    colProblems: 'Проблемы',
    totalsRow: 'Сток по ценам ({{count}} SKU)',
    recalc: 'Пересчитать по наценкам',
    recalcDone: 'Пересчитано цен: {{count}}',
    editTitle: 'Правка карточки',
    fType: 'Тип изделия',
    fCategory: 'Категория сайта',
    fCategoryExtra: 'Дополнительные категории',
    fName: 'Название на сайте',
    fShort: 'Короткое описание',
    fDescription: 'Описание',
    fFeatures: 'Пункты описания (по одному в строке)',
    fSpecs: 'Характеристики (ключ: значение в строке)',
    fGroup: 'Ключ группы вариантов (цвета одной модели)',
    fVariantLabel: 'Название варианта',
    fSeoTitle: 'SEO-заголовок',
    fSeoDescription: 'SEO-описание',
    fDelivery: 'Срок доставки (мин–макс)',
    fWarranty: 'Гарантия, месяцев',
    fImages: 'Картинки',
    fAddImage: 'Добавить картинку',
    fPrimary: 'Главная',
    fMakePrimary: 'Сделать главной',
    fRemove: 'Удалить',
    fPriceB2c: 'Цена B2C (ручная)',
    fPriceB2b: 'Цена B2B (ручная)',
    fRrp: 'RRP поставщика',
    fMarkupB2c: 'Наценка B2C для SKU, %',
    fMarkupB2b: 'Наценка B2B для SKU, %',
    fSiteAction: 'Видимость на сайте',
    siteAction: { auto: 'Автоматически', show: 'Показывать', preorder: 'Предзаказ', hide: 'Скрыть' },
    calc: 'расчёт {{value}}',
    siteJson: 'JSON, который получит сайт',
    detailDescription: 'Description',
    detailSpecs: 'Specifications',
    detailDelivery: 'Delivery',
    deliveryText: 'Pickup by Treejar from the supplier warehouse, delivery across the UAE within {{min}}–{{max}} working days after order confirmation.',
    warrantyBadge: '{{months}}-month warranty',
    deliveryBadge: '{{min}}–{{max}} days',
    related: 'Related products',
    status: {
      none: 'Не подготовлен',
      draft: 'Черновик',
      approved: 'Одобрен поставщиком',
      queued: 'Отправляется…',
      live: 'На сайте',
      failed: 'Отклонён сайтом',
      archived: 'В архиве',
    },
    problems: {
      contract_required: 'Нужен подписанный договор',
      approval_required: 'Нужно одобрение поставщика',
      excluded_by_partner: 'Исключено поставщиком',
      category_missing: 'Категория сайта не сопоставлена',
      image_missing: 'Нет картинки',
      name_missing: 'Нет названия',
      price_missing: 'Нет цены',
      price_below_min: 'Цена ниже минимума перепродажи',
      discontinued: 'Снят с продажи',
    },
    apprTitle: 'Одобрение поставщиком размещения',
    apprDesc: 'Поставщик просматривает карточки, снимает галочки с того, что размещать нельзя, и подтверждает остальное. Сохраняются подпись, имя и время; владелец получает список по почте.',
    apprExclude: 'Не размещать',
    apprMethod: 'Способ подтверждения',
    methods: { tablet_signature: 'Подпись на планшете', sms_code: 'Код по SMS / WhatsApp', portal: 'Подтверждение в портале', scan: 'Подписанный скан' },
    apprName: 'Кто одобрил (имя)',
    apprContact: 'Контакт (e-mail или телефон)',
    apprNotes: 'Примечание',
    apprSign: 'Поставщик расписывается здесь',
    apprClear: 'Очистить',
    apprSubmit: 'Зафиксировать одобрение',
    apprSubmitting: 'Записываем…',
    apprDone: 'Одобрение записано: {{count}} позиций',
    apprHistory: 'Прежние одобрения',
    apprNone: 'Одобрений ещё нет.',
    apprRow: '{{name}} · {{method}} · {{count}} позиций · исключено {{excluded}}',
    apprNeedProducts: 'Сначала опубликуйте прайс: одобрять пока нечего.',
    apprSelected: 'Разместить {{count}}, исключено {{excluded}}',
    ctrTitle: 'Договор с партнёром',
    ctrDesc: 'Формируется по шаблону Treejar с условиями партнёра. Без подписанного действующего договора нет публикации, броней и заказов.',
    ctrTemplate: 'Шаблон',
    ctrStart: 'Действует с',
    ctrEnd: 'Действует по',
    ctrTerms: 'Условия',
    ctrCreate: 'Создать договор',
    ctrCreating: 'Создаём…',
    ctrCreated: 'Договор {{number}} создан',
    ctrPreview: 'Предпросмотр',
    ctrPdf: 'Скачать PDF',
    ctrSend: 'Отправить партнёру',
    ctrSent: 'Отправлено на {{email}}',
    ctrSign: 'Подписать',
    ctrSignerName: 'Имя подписанта (сторона партнёра)',
    ctrSignTablet: 'Подпись на планшете',
    ctrSignScan: 'Загрузить подписанный скан',
    ctrScanFile: 'Подписанный скан (PDF/JPG)',
    ctrSigned: 'Подписал(а) {{name}}',
    ctrHistory: 'Версии',
    ctrNone: 'Договора ещё нет.',
    ctrNoTemplates: 'Нет активного шаблона договора. Создайте его в Настройках.',
    ctrStatus: { Draft: 'Черновик', Sent: 'Отправлен', Signed: 'Подписан', Expired: 'Истёк' },
    ctrSignDone: 'Договор подписан. Партнёр переведён в статус «Активен».',
    sendTitle: 'Отправить подготовленные листинги на treejartrading.ae',
    sendDesc: 'Отправляет только администратор. Предпроверки: подписанный договор, одобрение поставщика, категория сайта, главная картинка, обе цены, тексты. Пока хоть один выбранный SKU не проходит, отправки нет.',
    sendSelectReady: 'Выбрать все готовые',
    sendSelected: 'Выбрано: {{count}}',
    sendButton: 'Отправить на сайт',
    sendForce: 'Отправить несмотря на предупреждения',
    sending: 'Отправляем…',
    sendDone: 'Отправлено: принято {{ok}}, отклонено {{failed}}',
    sendNotAdmin: 'Отправлять листинги на сайт может только администратор.',
    sendNotConfigured: 'API сайта не настроен: укажите адрес в Настройках → Интеграция с сайтом и SITE_API_TOKEN на сервере.',
    sendBlocked: 'Заблокировано: {{problems}}',
    openOnSite: 'Открыть на сайте',
    archive: 'Архивировать на сайте',
    archiveReason: 'Причина',
    archived: '{{sku}} в архиве',
    reasons: { withdrawn_by_partner: 'Выведен поставщиком', contract_ended: 'Договор закончился', replaced: 'Заменён', admin: 'Решение администратора' },
    pushAvailability: 'Отправить остатки сейчас',
    pushDone: 'Остатки отправлены: {{status}}',
    pubTitle: 'Публикации',
    pubNone: 'Публикаций ещё не было.',
    pubRow: '{{kind}} · {{status}} · принято {{ok}} / отклонено {{failed}}',
    pubKind: { listings: 'Листинги', availability: 'Остатки', archive: 'Архив' },
    pubStatus: { queued: 'В очереди', sent: 'Отправлено', acknowledged: 'Принято', partial: 'Принято частично', failed: 'Ошибка' },
    summaryContract: 'Договор',
    summaryApproval: 'Одобрение',
    summaryReady: 'Готово к отправке',
    summaryLive: 'На сайте',
    yes: 'да',
    no: 'нет',
    none: 'нет',
    error: 'Ошибка: {{code}}',
  },
  siteint: {
    tab: 'Интеграция с сайтом',
    title: 'Интеграция с treejartrading.ae',
    desc: 'Отправка одобренных листингов и ежедневных остатков на сайт, ключи pull-API для сайта, вебхуки, карта категорий. Контракт: docs/SITE-API.md.',
    apiUrl: 'Адрес API сайта',
    apiUrlHint: 'Например https://treejartrading.ae/api/internal/partner. Токен отправки SITE_API_TOKEN хранится в .env сервера.',
    mediaBase: 'Публичный адрес медиа (ссылки на картинки)',
    tokenOk: 'Токен отправки на сервере задан',
    tokenMissing: 'SITE_API_TOKEN на сервере не задан',
    scheduler: 'Планировщик (снимок 06:00 Дубай и вебхуки)',
    on: 'включён',
    off: 'выключен',
    save: 'Сохранить',
    saved: 'Сохранено',
    test: 'Проверить связь',
    testResult: 'Сайт ответил {{status}}',
    channels: 'Каналы цен и видимость по умолчанию',
    markupB2b: 'Наценка B2B по умолчанию, %',
    lowStock: 'Порог «мало на складе», шт.',
    deliveryDays: 'Срок доставки на сайте (мин–макс)',
    hideAfter: 'Скрывать при возрасте данных, дней',
    keys: 'Ключи API для сайта (pull)',
    keysDesc: 'Сайт читает по ключу листинги, остатки, ежедневные снимки и события. Токен показывается один раз.',
    keyName: 'Название ключа',
    createKey: 'Создать ключ',
    keyCreated: 'Скопируйте токен сейчас, больше он не покажется:',
    copy: 'Копировать',
    copied: 'Скопировано',
    revoke: 'Отозвать',
    revoked: 'Ключ отозван',
    noKeys: 'Ключей пока нет.',
    scope: {
      listings_read: 'чтение листингов',
      stock_read: 'чтение остатков',
      events_read: 'чтение событий',
      listings_write: 'правка превью и фото',
      sales_write: 'передача продаж',
      sales_read: 'чтение продаж',
    },
    lastUsed: 'использован {{date}}',
    neverUsed: 'не использовался',
    webhooks: 'Вебхуки',
    webhooksDesc: 'Сайт подписывается сам через POST /site/v1/webhooks. Доставки подписаны HMAC-SHA256.',
    noWebhooks: 'Вебхуков нет.',
    pending: 'Событий в очереди доставки: {{count}}',
    map: 'Карта категорий: тип в хабе → категория сайта',
    mapDesc: 'Основной slug treejartrading.ae (chairs, executive-chair, desks-tables, sofas, storage …) и дополнительные категории через запятую.',
    mapType: 'Тип в хабе',
    mapPrimary: 'Основной slug',
    mapAdditional: 'Дополнительные',
    mapSave: 'Сохранить карту',
    mapSaved: 'Карта категорий сохранена',
    snapshot: 'Собрать снимок сейчас',
    snapshotDone: 'Снимок за {{date}}: {{items}} позиций',
    lastSnapshot: 'Последний снимок: {{date}}, {{items}} позиций',
    noSnapshot: 'Снимков ещё нет.',
    publications: 'Последние публикации',
    delete: 'Удалить',
  },
  ord: {
    description: 'Заказы поставщикам читаются из Zoho Books по партнёрам, сопоставленным с Vendor. Источник правды — Zoho; хаб хранит копию только для чтения и обновляет её ежедневно.',
    syncNow: 'Загрузить из Zoho',
    syncStarted: 'Заказы загружаются из Zoho в фоне…',
    syncRunning: 'Идёт загрузка из Zoho…',
    lastSync: 'Zoho: {{date}} · загружено {{imported}}, пропущено {{skipped}}',
    zohoNotConfigured: 'Ключи Zoho (client id, secret, refresh token) на сервере не заданы.',
    unmatched: 'Поставщики Zoho без партнёра в хабе',
    search: 'Поиск по номеру, поставщику, референсу',
    colReference: 'Референс',
    colTotal: 'Сумма с НДС',
    colOrdered: 'Заказан',
    colExpected: 'Ожидается',
    colReceived: 'Получено',
    emptyAll: 'Заказов пока нет. Загрузите их из Zoho.',
    footerZoho: 'Источник: заказы поставщикам Zoho Books, партнёры сопоставлены по названию или id Vendor',
    openZoho: 'Открыть в Zoho',
    ordered: 'заказан',
    expected: 'ожидается',
    vat: 'НДС',
    timelineReceived: 'Получен / забран',
    timelineBilled: 'Выставлен счёт',
    billed: 'выставлен',
    syncedAt: 'Загружено из Zoho {{date}}',
    billedStatus: 'Счёт (Zoho)',
    receivedStatus: 'Приёмка (Zoho)',
    paymentStatus: 'Статус оплаты',
    noArrivals: 'Открытых поставок на ближайшие недели нет.',
  },
  fbp: {
    eyebrow: 'Идеи и проблемы',
    title: 'Замечания',
    description: 'Всё, что отправлено кнопкой «Идея / Проблема». Администратор одобряет замечание и нажимает «Запустить исправление»: робот берёт его в течение 10 минут, исправляет, выкладывает и отчитывается здесь.',
  },
  pc: {
    onboardingCount: 'в онбординге: {{count}}',
    statStale: 'Прайс устарел',
    staleHint: 'активные поставщики без прайса за {{days}} дней',
    colContract: 'Договор',
    footer: '{{shown}} из {{total}} поставщиков',
    footerNote: 'Данные из кабинетов поставщиков и импортов прайсов · цены без НДС',
    tabs: { overview: 'Обзор', listings: 'Листинги и цены', site: 'Сайт', lists: 'Прайс-листы', terms: 'Условия и реквизиты', contract: 'Договор', orders: 'Заказы (Zoho)' },
    openPreview: 'Превью карточек',
    openSite: 'Открыть сайт',
    websiteTitle: 'Сайт поставщика',
    websiteSub: 'Адрес каталога хранится в карточке и подставляется в договор и листинг.',
    websiteSaved: 'Адрес сайта сохранён',
    websiteNote: 'Автоматический разбор сайта не выполняется. Товары, цены и остатки попадают в хаб из прайс-листа поставщика (PDF, Excel, CSV или фото) через «Импорт прайса», а карточки для сайта готовятся на шаге «Превью».',
    markups: 'Наценки',
    days: 'дн.',
    hours: 'ч',
    readyTitle: 'Путь к сайту',
    readySub: 'Шаги онбординга; нажмите на шаг, чтобы перейти.',
    filled: 'заполнено',
    noTrn: 'нет TRN или склада',
    readyOf: 'готово {{ready}} из {{total}} · фото у {{images}}',
    liveOf: 'на сайте {{live}} из {{total}}',
    siteNotConfigured: 'Адрес API сайта не задан: отправка идёт в песочницу. Настройки → Интеграция с сайтом.',
    statReady: 'Готово к сайту',
    statLive: 'На сайте',
    listingsSub: 'Себестоимость из прайса, цены каналов по наценкам B2C {{b2c}} % и B2B {{b2b}} % (оранжевым — заданы вручную).',
    colSku: 'Артикул',
    colName: 'Название для сайта',
    colCost: 'Себест., AED',
    colStock: 'Остаток',
    colAvail: 'Доступность',
    colListing: 'Листинг',
    noName: 'без названия',
    noListings: 'Позиций ещё нет: загрузите прайс.',
    listingsFooter: '{{total}} позиций · готово {{ready}} · на сайте {{live}}',
    avail: { in_stock: 'В наличии', low_stock: 'Мало', out_of_stock: 'Нет на складе', in_transit: 'В пути', discontinued: 'Снят' },
    websiteSub2: 'Адрес каталога на сайте дилера. Разбор сайта собирает карточки товаров (фото, описание, характеристики, цена сайта) и привязывает их к артикулам прайса.',
    websiteNote2: 'Фото и описания с сайта попадают в превью карточек: при публикации прайса — сами, для уже опубликованных позиций — кнопкой «Подтянуть в превью». Заполняются только пустые поля; цена сайта становится рекомендованной розничной (RRP).',
    scan: 'Разобрать сайт',
    rescan: 'Разобрать заново',
    scanStarted: 'Разбор сайта запущен — обычно 1–3 минуты',
    scanRunning: 'Идёт разбор…',
    urlRequired: 'Укажите адрес сайта',
    scanPages: 'Страниц',
    scanProducts: 'Карточек на сайте',
    scanMatched: 'Совпало с прайсом',
    scanApplied: 'В превью',
    scanStatus: { queued: 'В очереди', running: 'Идёт разбор', done: 'Готово', failed: 'Ошибка' },
    lastScan: 'последний разбор: {{date}}',
    neverScanned: 'Сайт ещё не разбирался.',
    applyToPreview: 'Подтянуть в превью',
    applyOverwrite: 'Заменить фото с сайта',
    applyOverwriteHint: 'Заменить все фото листингов фотографиями с сайта, включая загруженные вручную (описания — только в пустые поля)',
    applyToPreviewHint: 'Фото с сайта ставится, если у карточки фото нет или там только миниатюра из PDF-прайса; описания и характеристики — в пустые поля',
    applied: 'Данные с сайта подтянуты в {{count}} листингов',
    appliedNone: 'Нечего подтягивать: нет совпавших карточек или поля уже заполнены',
    openSiteTab: 'Карточки с сайта ({{count}}) →',
    siteProductsTitle: 'Карточки с сайта поставщика',
    siteProductsSub: 'Нажмите на привязку, чтобы указать артикул вручную; пустая строка снимает привязку.',
    siteFilter: { all: 'Все', matched: 'Совпали', unmatched: 'Без артикула' },
    colSiteProduct: 'Товар на сайте',
    colSitePrice: 'Цена на сайте',
    colSiteAvail: 'Наличие',
    colMatched: 'Артикул прайса',
    colApplied: 'Подтянуто',
    matchPlaceholder: 'артикул из прайса',
    matchHint: 'Указать артикул вручную',
    noMatch: 'не найден',
    noSiteProducts: 'Карточек нет — запустите разбор сайта.',
    pullSite: 'Подтянуть с сайта',
    pullSiteHint: 'Фото, описания, характеристики и цену сайта (RRP) из разобранного сайта поставщика — в пустые поля листингов',
    readOnly: 'Условия редактируют администратор и менеджер по партнёрам.',
    noOrders: 'Заказов этому поставщику в Zoho Books за последние 12 месяцев нет.',
  },
  imd: {
    noImage: 'Картинки в прайсе для этой строки не найдено',
    imageFromPdf: 'Картинка вырезана из PDF-прайса по положению артикула; станет первым фото листинга после публикации.',
    imageHint: 'Фото можно добавить на шаге «Превью» или подтянуть с сайта поставщика.',
    reviewedYes: 'Проверено',
    markReviewed: 'Отметить проверенной',
    include: 'Вернуть в публикацию',
    exclude: 'Исключить из публикации',
    openSku: 'Открыть SKU в каталоге',
    excluded: 'исключена',
    secPrices: 'Цены и доплаты',
    secStock: 'Остатки и упаковка',
    secProduct: 'Товар',
    secSecondPass: 'Второй проход модели (сверка чисел)',
    catalogPrice: 'Цена в каталоге сейчас',
    catalogStock: 'Остаток в каталоге сейчас',
    packingVariants: 'Варианты упаковки',
    packing: 'Упаковка',
    spPrices: 'Цены на странице',
    versionHint: 'Черновик импорта {{id}}. Значения правятся прямо в таблице.',
    whyTitle: 'Почему строка требует ручной проверки',
    why: { risk: 'Риск {{risk}} AED не ниже порога {{threshold}} AED. Риск — оценка цены ошибки: для новой позиции это 25 % от стоимости остатка ({{stock}} × {{price}} × 0,25), для уже известной — разница с прежней ценой, умноженная на количество, или 25 % от стоимости изменения остатка. Чем больше денег за строкой, тем нужнее подтверждение человека.', flags: 'Сработали проверки: {{flags}}.', low_confidence: 'Уверенность распознавания {{conf}} % ниже 85 %.' },
    whyAction: 'Сверьте цену и остаток с прайсом (страница указана в шапке), поправьте значения в таблице, если нужно, и нажмите «Отметить проверенной».',
    attach: 'Картинки из PDF: {{count}} из {{total}}',
    attachHint: 'Заново вырезать картинки позиций из PDF-прайса',
  },
  portalContract: {
    none: 'Договор ещё не выпущен. Менеджер Treejar отправит его после визита.',
    pdf: 'Скачать PDF',
    signedBy: 'Подписал(а) {{name}} {{date}}',
    valid: 'Действует {{from}} – {{to}}',
  },
};
